import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import { Lazyload } from 'vant'

// 引入模块后自动生效
import '@vant/touch-emulator'
Vue.config.productionTip = false
Vue.use(Lazyload)

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
